export default __webpack_public_path__ + "static/media/logoLine.3a673da2.webp";